module.exports = __webpack_public_path__ + "img/rongxin.427090b0.png";